export { errorReportsApi, useSendErrorReportMutation } from './api';

export {
  ErrorReportsEndpoints,
  type SendErrorReportRequest,
  type SendErrorReportResponse,
} from './types';
